/**
 * Notiz-Icon hinter einer Bezeichnung: zeigt an, dass es eine Notiz gibt, der Text steht im
 * Tooltip – mit seinen Zeilenumbrüchen. Ohne Notiz erscheint nichts.
 *
 * Mit `problem` steht statt des Notiz-Icons ein rotes Ausrufezeichen: Die Notiz beschreibt dann,
 * was hakt.
 *
 * Kennt keine Fachlichkeit: Wessen Notiz es ist und ob sie ein Problem beschreibt, entscheidet
 * der Aufrufer.
 */
import React from "react";
import { Box, Tooltip } from "@mui/material";
import {
  StickyNote2Outlined as NoteIcon,
  PriorityHigh as ProblemIcon,
} from "@mui/icons-material";
import { colors } from "../../../styles/theme";

interface NoteIndicatorProps {
  note?: string | null;
  /** Die Notiz beschreibt ein Problem – rotes Ausrufezeichen statt Notiz-Icon */
  problem?: boolean;
}

const NoteIndicator: React.FC<NoteIndicatorProps> = ({ note, problem }) => {
  if (!note && !problem) return null;
  const Icon = problem ? ProblemIcon : NoteIcon;
  return (
    <Tooltip title={<Box sx={{ whiteSpace: "pre-line" }}>{note}</Box>}>
      <Icon
        aria-label={problem ? "Problem" : "Notiz"}
        sx={{
          fontSize: 16,
          color: problem ? colors.status.error.main : colors.text.secondary,
          flexShrink: 0,
        }}
      />
    </Tooltip>
  );
};

export default NoteIndicator;
